import { render, staticRenderFns } from "./newshebei.vue?vue&type=template&id=a321f120&scoped=true&"
import script from "./newshebei.vue?vue&type=script&lang=js&"
export * from "./newshebei.vue?vue&type=script&lang=js&"
import style0 from "./newshebei.vue?vue&type=style&index=0&id=a321f120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a321f120",
  null
  
)

export default component.exports